module.exports = __webpack_public_path__ + "img/delete-v2 2.630fc0cd.svg";